import { Box } from '@mui/material';
import moment from 'moment';

import { WorkflowHistoryEntry } from '../../../types';

type Props = {
  workflowHistory: WorkflowHistoryEntry[];
  showHistory: boolean;
  fieldKey: keyof WorkflowHistoryEntry;
  format?: string;
};

export const DateHistoryCell = (props: Props) => {
  const { workflowHistory, showHistory, fieldKey, format = 'L' } = props;

  if (showHistory && workflowHistory.length > 1) {
    return (
      <Box>
        {workflowHistory.map((entry, index) => (
          <Box key={index}>{moment(entry[fieldKey]).format(format)}</Box>
        ))}
      </Box>
    );
  }

  return <Box>{moment(workflowHistory[0][fieldKey]).format(format)}</Box>;
};
